import React from 'react';
import { ValidationIcon } from '../../../icons';

interface AddressFieldsProps {
  formData: {
    street: string;
    number: string;
    complement?: string;
    neighborhood: string;
    city?: string;
    state?: string;
  };
  errors: {
    street?: string;
    number?: string;
    neighborhood?: string;
  };
  isCepValidAndFound: boolean;
  isStreetValid: boolean;
  isNumberValid: boolean;
  isNeighborhoodValid: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddressFields: React.FC<AddressFieldsProps> = ({
  formData,
  errors,
  isCepValidAndFound,
  isStreetValid,
  isNumberValid,
  isNeighborhoodValid,
  onChange,
}) => {
  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';
  const disabledClass = 'bg-gray-100 dark:bg-gray-800 text-gray-400 cursor-not-allowed';

  const inputClassWithDisabled = (hasError: boolean, isDisabled: boolean) => {
    let classes = inputBaseClass;
    if (isDisabled) {
      classes += ` ${disabledClass}`;
    } else {
      classes += ` ${hasError ? errorBorderClass : normalBorderClass}`;
    }
    return classes;
  };

  return (
    <>
      {/* Campos ocultos para manter compatibilidade com backend */}
      <input type="hidden" name="city" value={formData.city} />
      <input type="hidden" name="state" value={formData.state} />

      <div className="relative">
        <label htmlFor="street" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
          Endereço
        </label>
        <div className="relative">
        <input
          type="text"
          name="street"
          id="street"
          value={formData.street}
          onChange={onChange}
          minLength={3}
          maxLength={150}
          disabled={!isCepValidAndFound}
          className={inputClassWithDisabled(Boolean(errors.street), !isCepValidAndFound)}
          aria-describedby={errors.street ? 'street-error' : undefined}
        />
        <ValidationIcon isValid={isStreetValid && isCepValidAndFound} />
        {errors.street && (
          <p id="street-error" className="text-xs text-red-500 mt-1">
            {errors.street}
          </p>
        )}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-4 gap-y-6">
        <div className="sm:col-span-1 relative">
          <label htmlFor="number" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
            Número
          </label>
          <div className="relative">
          <input
            type="text"
            name="number"
            id="number"
            value={formData.number}
            onChange={onChange}
            minLength={1}
            maxLength={10}
            disabled={!isCepValidAndFound}
            className={inputClassWithDisabled(Boolean(errors.number), !isCepValidAndFound)}
            aria-describedby={errors.number ? 'number-error' : undefined}
          />
          <ValidationIcon isValid={isNumberValid && isCepValidAndFound} />
          {errors.number && (
            <p id="number-error" className="text-xs text-red-500 mt-1">
              {errors.number}
            </p>
          )}
          </div>
        </div>
        <div className="sm:col-span-3">
          <label htmlFor="complement" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
            Complemento
          </label>
          <input
            type="text"
            name="complement"
            id="complement"
            value={formData.complement ?? ''}
            onChange={onChange}
            maxLength={150}
            disabled={!isCepValidAndFound}
            className={inputClassWithDisabled(false, !isCepValidAndFound)}
          />
        </div>
      </div>

      <div className="relative">
        <label htmlFor="neighborhood" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
          Bairro
        </label>
        <div className="relative">
        <input
          type="text"
          name="neighborhood"
          id="neighborhood"
          value={formData.neighborhood}
          onChange={onChange}
          maxLength={150}
          disabled={!isCepValidAndFound}
          className={inputClassWithDisabled(Boolean(errors.neighborhood), !isCepValidAndFound)}
          aria-describedby={errors.neighborhood ? 'neighborhood-error' : undefined}
        />
        <ValidationIcon isValid={isNeighborhoodValid && isCepValidAndFound} />
        {errors.neighborhood && (
          <p id="neighborhood-error" className="text-xs text-red-500 mt-1">
            {errors.neighborhood}
          </p>
        )}
        </div>
      </div>
    </>
  );
};

export default AddressFields; 